module.exports = __webpack_public_path__ + "9cf5c041793db985e3785cecddb79822.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/slide.png
// module id = 2162
// module chunks = 0